package com.example.mystybag.e5AiSearch.helpers

actual class PlatformContext

actual object E5Platform {
    private var ctx: PlatformContext = PlatformContext()

    fun init() {
        ctx = PlatformContext()
    }

    actual fun appContext(): PlatformContext = ctx

    actual suspend fun createRunner(
        ctx: PlatformContext,
        modelAssetName: String,
        maxLen: Int,
        dim: Int
    ): PlatformOnnxRunner = WebOnnxRunner.create(
        modelUrl = modelAssetName,
        maxLen = maxLen,
        dim = dim
    )

    actual fun log(tag: String, msg: String) {
        kotlin.js.console.log("[$tag] $msg")
    }
}
